import * as ROUTES from '@/router/route-names'

export default [
  {
    path: '/:accountId/data-request',
    name: ROUTES.DATA_REQUEST_SELECTOR,
    component: () => import('../views/highwing/DataRequestSelector.vue'),
  },
  {
    path: '/:accountId/highwing/:formId/:userId',
    name: ROUTES.HIGHWING_DEMO_USER_ROUTE,
    component: () => import('../views/highwing/HighwingDemo.vue'),
  },
  {
    path: '/:accountId/highwing/:formId',
    name: ROUTES.HIGHWING_DEMO_ROUTE,
    component: () => import('../views/highwing/HighwingDemo.vue'),
  },
  {
    path: '/:accountId/data-request/:formId/:userId',
    name: ROUTES.DATA_REQUEST_USER,
    component: () => import('../views/highwing/DataRequest.vue'),
  },
  {
    path: '/:accountId/data-request/:formId',
    name: ROUTES.DATA_REQUEST,
    component: () => import('../views/highwing/DataRequest.vue'),
  },
]
